export default function Required(){
  return (
    <span className="text-red-500">*</span>
  )
}